import { PublicInfoResponse } from '@app/core/members/member.service';
import { MemberIdentifier } from '@app/core/_models/member-interface';
import { ChangeDetectorRef, Directive, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import storage from 'local-storage-fallback';

import { LOGIN_ID_STORAGE_ITEM_KEY } from '@app/+login/deprecated-hybrid/consts';

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class V2AuthConfirmationAbstract implements OnInit, OnDestroy {
  public identifier?: MemberIdentifier;
  public publicInfo: PublicInfoResponse;

  protected unsubscribe$ = new Subject();

  protected constructor(protected router: Router,
                        protected route: ActivatedRoute,
                        protected cdr: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.setupStateData();
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  protected setupStateData(): void {
    const state = history.state;
    this.identifier = state.identifier || JSON.parse(storage.getItem(LOGIN_ID_STORAGE_ITEM_KEY) as string);
    this.publicInfo = state.publicInfo;
  }
}
